/* Describes type of locator requested.  Search results will contain a set of one of the chosen type. */
export enum LocatorTools {
  HealthCenter,
  HealthCenterControlledNetwork,
  MigrantSeasonalHeadStart,
  OrganTransplantCenter,
  HIVMedicalProvider
}
